import { en } from './en';
import { hi } from './hi';

export const translations = {
    en,
    hi,
};
